<template>
  <div class="handle-record">
    <div
      class="technician"
      v-if="orderType==='caseOrder' && technicianList.length!==0"
    >
      <ul class="technician-box">
        <li
          v-for="item in technicianList"
          class="technician-tab"
          :class="{ active: item.orderTechnicianId }"
          :key="item.orderTechnicianId"
          @click="onEnterpriseType(item)"
        >
          <h3
            class="title"
            :title="`${item.workOrderCode} ${ item.technicianName}`"
          >{{item.workOrderCode}} {{ item.technicianName }}</h3>
          <div class="arrow icon icon-jiantou"></div>
        </li>
      </ul>
    </div>
    <div
      class="content-box"
      v-if="technicianList.length"
    >
    <template v-if="`${caseOrderType}`!=='50'">
      <h1 class="item-title">{{$t('asm_handle_record.chu_li_miao_shu')}}:</h1>
      <P>{{workOrderDeviceInfo.serviceFeedback || '-'}}</P>
    </template>
      <!-- <h1 class="item-title">零件更换记录</h1> -->
      <replace-parts-record
        :orderTechnicianId="orderTechnicianId"
        :orderType="orderType"
        :caseOrderType="caseOrderType"
      ></replace-parts-record>
    </div>
    <p v-if="technicianList.length===0">{{$t('Common.com_no_data')}}</p>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import replacePartsRecord from './replace_parts_record.vue';
/**
 * 处理记录
 */
export default {
  name: 'handle_record',
  inject: ['getCaseInfo', 'checkActionEnable'],
  computed: {
    caseInfo() {
      return this.getCaseInfo();
    },
    actionEnable() {
      return this.checkActionEnable();
    },
  },
  mixins: [],
  components: { replacePartsRecord },
  props: {
    caseOrderId: [Number, String],
    orderType: [String], // workOrder是工单  caseOrder是案例订单
    caseOrderType: [Number, String] // 工单类型：caseOrderType 10-维修，20-保养，30-培训，40-安装 50 - 返工
    // workOrderId: [Number, String],
  },
  data() {
    return {
      technicianList: [],
      orderTechnicianId: '',
      // workOrderDesc: ''
      workOrderDeviceInfo: {}
    };
  },
  watch: {
    'caseInfo.serviceClass': {
      immediate: true,
      handler(val) {
        if (val) {
          if (this.orderType === 'caseOrder') {
            // 工单
            this.getTechnicianList();
          } else {
            // 案例订单
            this.orderTechnicianId = this.caseInfo.orderTechnicianId;
            // this.workOrderDesc = this.caseInfo.workOrderDesc;
            this.getTechnicianList();
          }
        }
      },
    },

  },
  methods: {
    onEnterpriseType: function (row) {
      this.orderTechnicianId = row.orderTechnicianId;
      // this.workOrderDesc = row.workOrderDesc;
      if (this.orderType !== 'caseOrder') {
        this.getWorkOrderDeviceInfo();
      }

    },
    getTechnicianList() {
      this.$getJSON(apis.workOrderTechnicianList, { caseOrderId: this.caseOrderId }).then((res) => {
        this.technicianList = res.data || [];
        if (this.technicianList.length) {
          this.orderTechnicianId = this.technicianList[0].orderTechnicianId;
          // this.workOrderDesc = this.technicianList[0].workOrderDesc;
        }
        if (this.caseInfo.workOrderId && this.orderTechnicianId) {
          this.getWorkOrderDeviceInfo();
        }
      });
    },
    getWorkOrderDeviceInfo() {
      this.$getJSON(apis.WorkOrderDeviceInfo, { workOrderId: this.caseInfo.workOrderId, orderTechnicianId: this.orderTechnicianId }).then((res) => {
        this.workOrderDeviceInfo = res.data || {};
      });
    },
  },

  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.handle-record {
  height: 100%;
  width: 100%;
  display: flex;
  padding: 16px;
  .technician {
    // padding: 38px 24px 11px;
    // margin: 24px 0 24px 24px;
    // margin: 24px;s
    // width: 220px;
    padding: 0 16px;
    // margin-right: 24px;
    width: 220px;
    // border: 1px solid #E4EBF2;
    border-right: 1px solid #e4ebf2;
    height: 100%;
    // border-bottom: 1px solid #E4EBF2;
    .technician-box {
      display: flex;
      // width: 900px;
      // justify-content: space-between;
      flex-direction: column;
      .technician-tab {
        flex: 1;
        // width: 234px;
        margin-bottom: 12px;
        cursor: pointer;
        background: #ffffff;
        border: 1px solid #e4ebf2;
        height: 40px;
        // padding: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        position: relative;
        .title {
          height: 40px;
          font-size: 12px;
          // font-weight:bold;
          color: #495057;
          line-height: 40px;
          text-align: center;
          width: 100%;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap; //溢出不换行
        }
        .arrow {
          display: none;
        }
        &:last-child {
          margin-right: 0;
        }
      }

      .technician-tab.active {
        border: 2px solid #0d9ae0;
        .title {
          font-weight: bold;
        }
        .arrow {
          position: absolute;
          right: -1px;
          bottom: -3px;
          font-size: 28px;
          color: #0d9ae0;
          display: block;
        }
      }
    }
  }
  .content-box {
    flex: 1;
    padding: 0 16px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
}
</style>
